import moment from "moment";


export const UTCToLocalString = (utc: string, format: string) => {
    return moment.utc(utc).local().format(format);
};

export const getUtcZeroTime = (date: string, format: string): string  => {
    return moment(date).utc().format(format);
};

export const compareDate = (date1: string, date2: string, sort: "asc" | "desc" = "asc") => {
    const diff = new Date(date1).getTime() - new Date(date2).getTime();
    return sort === "asc" ? diff : -diff;
};

export const to24HourTime = (hour: number, meridiem: "AM" | "PM") => {
    if (meridiem === 'PM') {
        if (hour === 12) {
            return 12;
        }
        return hour + 12;
    } else {
        if (hour === 12) {
            return 0;
        }
        return hour;
    }
};

export const to12HourTime = (hour: number) => {
    if (hour === 0 || hour === 12) {
        return 12;
    }
    return hour % 12;
};
